// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__17sh-","notes":"Notes_notes__3oziN"};